
// import React, { useState } from "react";
// import { useCart } from "../pages/CartContext";
// import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import { useNavigate } from "react-router-dom";

// const PaymentPage = () => {
//   const { cart, setCart } = useCart();
//   const stripe = useStripe();
//   const elements = useElements();
//   const navigate = useNavigate();

//   const [isProcessing, setIsProcessing] = useState(false);
//   const [message, setMessage] = useState("");

//   const [address, setAddress] = useState({
//     name: "",
//     email: "",
//     line1: "",
//     city: "",
//     state: "",
//     postal_code: "",
//   });

//   const subtotal = cart.reduce((acc, item) => {
//     const price = parseFloat(item.price.replace(/[^0-9.]/g, ""));
//     return acc + price * (item.quantity || 1);
//   }, 0);

//   const taxRate = 0.0725;
//   const tax = subtotal * taxRate;
//   const total = subtotal + tax;

//   const handlePayment = async () => {
//     setIsProcessing(true);
//     setMessage("");

//     // const response = await fetch("http://127.0.0.1:5000/create-payment-intent", {
//     const response = await fetch("http://192.168.1.184:5000/create-payment-intent", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         amount: Math.round(total * 100),
//         email: address.email,
//         items: cart
//       })
//     });

//     const { clientSecret, error } = await response.json();

//     if (error) {
//       setMessage("Server error: " + error);
//       setIsProcessing(false);
//       return;
//     }

//     const cardElement = elements.getElement(CardElement);

//     const paymentResult = await stripe.confirmCardPayment(clientSecret, {
//       payment_method: {
//         card: cardElement,
//         billing_details: {
//           name: address.name,
//           email: address.email,
//           address: {
//             line1: address.line1,
//             city: address.city,
//             state: address.state,
//             postal_code: address.postal_code,
//           },
//         },
//       },
//     });

//     if (paymentResult.error) {
//       setMessage(`Payment failed: ${paymentResult.error.message}`);
//     } else if (paymentResult.paymentIntent.status === "succeeded") {
//       setMessage("Payment successful! Your order is confirmed.");
//       setCart([]);
//       navigate("/confirmation", {
//         state: { cart, total: total.toFixed(2), email: address.email },
//       });
//     }

//     setIsProcessing(false);
//   };

//   const handleChange = (e) => {
//     setAddress((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   return (
//     <div className="grid md:grid-cols-2 max-w-7xl mx-auto px-6 py-10 gap-10">
//       {/* LEFT SIDE */}
//       <div className="space-y-6">
//         <h1 className="text-xl font-semibold">Shipping & Payment Details</h1>

//         <div className="space-y-3">
//           <input name="name" placeholder="Full Name" value={address.name} onChange={handleChange} className="w-full border p-2 rounded" />
//           <input name="email" placeholder="Email" value={address.email} onChange={handleChange} className="w-full border p-2 rounded" />
//           <input name="line1" placeholder="Street Address" value={address.line1} onChange={handleChange} className="w-full border p-2 rounded" />
//           <div className="flex gap-2">
//             <input name="city" placeholder="City" value={address.city} onChange={handleChange} className="w-full border p-2 rounded" />
//             <input name="state" placeholder="State" value={address.state} onChange={handleChange} className="w-full border p-2 rounded" />
//             <input name="postal_code" placeholder="Zip Code" value={address.postal_code} onChange={handleChange} className="w-full border p-2 rounded" />
//           </div>
//         </div>

//         <div className="border p-4 rounded bg-white shadow mt-6">
//           <CardElement />
//         </div>

//         <button
//           onClick={handlePayment}
//           disabled={!stripe || isProcessing}
//           className="w-full bg-blue-600 text-white py-3 rounded font-bold mt-6"
//         >
//           {isProcessing ? "Processing..." : "Pay now"}
//         </button>

//         {message && <div className="text-green-600 mt-4">{message}</div>}
//       </div>

//       {/* RIGHT SIDE */}
//       <div className="bg-gray-50 p-6 rounded shadow-md">
//         <h2 className="text-lg font-semibold mb-4">Order Summary</h2>
//         {cart.map((item, index) => (
//           <div key={index} className="flex justify-between mb-3">
//             <div className="flex gap-3">
//               <img src={item.images?.[0]} alt={item.name} className="w-12 h-12 rounded border" />
//               <div>
//                 <p className="font-medium">{item.name}</p>
//                 <p className="text-xs text-gray-500">Size: {item.selectedSize} ({item.sizeType?.toUpperCase()})</p>
//               </div>
//             </div>
//             <p>
//               ${(parseFloat(item.price.replace(/[^0-9.]/g, "")) * (item.quantity || 1)).toFixed(2)}
//             </p>
//           </div>
//         ))}
//         <div className="flex justify-between mb-2">
//           <span>Subtotal:</span>
//           <span>${subtotal.toFixed(2)}</span>
//         </div>
//         <div className="flex justify-between mb-2">
//           <span>Estimated Tax:</span>
//           <span>${tax.toFixed(2)}</span>
//         </div>
//         <div className="mt-4 border-t pt-4 font-bold text-lg flex justify-between">
//           <span>Total:</span>
//           <span>${total.toFixed(2)}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PaymentPage;

import React, { useState } from "react";
import { useCart } from "../pages/CartContext";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";

const PaymentPage = () => {
  const { cart, setCart } = useCart();
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState("");

  const [address, setAddress] = useState({
    name: "",
    email: "",
    line1: "",
    city: "",
    state: "",
    postal_code: "",
  });

  const subtotal = cart.reduce((acc, item) => {
    const price = parseFloat(item.price.replace(/[^0-9.]/g, ""));
    return acc + price * (item.quantity || 1);
  }, 0);

  const taxRate = 0.0725;
  const tax = subtotal * taxRate;
  const total = subtotal + tax;

  const handlePayment = async () => {
    setIsProcessing(true);
    setMessage("");

    // const response = await fetch("http://192.168.1.184:5000/create-payment-intent", {
      const response = await fetch("https://shoe-website-p3no.onrender.com/create-payment-intent", { 

    // fetch("https://shoe-website-p3no.onrender.com/create-payment-intent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        amount: Math.round(total * 100),
        email: address.email,
        items: cart
      })
    });

    const { clientSecret, error } = await response.json();

    if (error) {
      setMessage("Server error: " + error);
      setIsProcessing(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const paymentResult = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
        billing_details: {
          name: address.name,
          email: address.email,
          address: {
            line1: address.line1,
            city: address.city,
            state: address.state,
            postal_code: address.postal_code,
          },
        },
      },
    });

    if (paymentResult.error) {
      setMessage(`Payment failed: ${paymentResult.error.message}`);
    } else if (paymentResult.paymentIntent.status === "succeeded") {
      // Save order to backend
      // await fetch("http://192.168.1.184:5000/save-order", {
        await fetch("https://shoe-website-p3no.onrender.com/save-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: address.email,
          name: address.name,
          address,
          cart,
          total: total.toFixed(2),
          timestamp: new Date().toISOString()
        })
      });

      setMessage("Payment successful! Your order is confirmed.");
      setCart([]);
      navigate("/confirmation", {
        state: { cart, total: total.toFixed(2), email: address.email },
      });
    }

    setIsProcessing(false);
  };

  const handleChange = (e) => {
    setAddress((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="grid md:grid-cols-2 max-w-7xl mx-auto px-6 py-10 gap-10">
      {/* LEFT SIDE */}
      <div className="space-y-6">
        <h1 className="text-xl font-semibold">Shipping & Payment Details</h1>

        <div className="space-y-3">
          <input name="name" placeholder="Full Name" value={address.name} onChange={handleChange} className="w-full border p-2 rounded" />
          <input name="email" placeholder="Email" value={address.email} onChange={handleChange} className="w-full border p-2 rounded" />
          <input name="line1" placeholder="Street Address" value={address.line1} onChange={handleChange} className="w-full border p-2 rounded" />
          <div className="flex gap-2">
            <input name="city" placeholder="City" value={address.city} onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="state" placeholder="State" value={address.state} onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="postal_code" placeholder="Zip Code" value={address.postal_code} onChange={handleChange} className="w-full border p-2 rounded" />
          </div>
        </div>

        <div className="border p-4 rounded bg-white shadow mt-6">
          <CardElement />
        </div>

        <button
          onClick={handlePayment}
          disabled={!stripe || isProcessing}
          className="w-full bg-blue-600 text-white py-3 rounded font-bold mt-6"
        >
          {isProcessing ? "Processing..." : "Pay now"}
        </button>

        {message && <div className="text-green-600 mt-4">{message}</div>}
      </div>

      {/* RIGHT SIDE */}
      <div className="bg-gray-50 p-6 rounded shadow-md">
        <h2 className="text-lg font-semibold mb-4">Order Summary</h2>
        {cart.map((item, index) => (
          <div key={index} className="flex justify-between mb-3">
            <div className="flex gap-3">
              <img src={item.images?.[0]} alt={item.name} className="w-12 h-12 rounded border" />
              <div>
                <p className="font-medium">{item.name}</p>
                <p className="text-xs text-gray-500">
                  Size: {item.selectedSize} ({item.sizeType?.toUpperCase()})
                </p>
              </div>
            </div>
            <p>
              ${(parseFloat(item.price.replace(/[^0-9.]/g, "")) * (item.quantity || 1)).toFixed(2)}
            </p>
          </div>
        ))}
        <div className="flex justify-between mb-2">
          <span>Subtotal:</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between mb-2">
          <span>Estimated Tax:</span>
          <span>${tax.toFixed(2)}</span>
        </div>
        <div className="mt-4 border-t pt-4 font-bold text-lg flex justify-between">
          <span>Total:</span>
          <span>${total.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
